import { routesEs } from './routes';

const localeEs = {
  es: {
    ...routesEs.es,
    ADD_COURSE_DIALOG_SEARCH: 'Buscar curso',
    ADD_COURSE_DIALOG_QUIT: 'Quitar',
    ADD_COURSE_DIALOG_ADD: 'Agregar',
    ADD_COURSE_DIALOG_SAVE: 'Guardar cambios',

    STAT_CARD_DESCRIPTION: 'vs semana anterior',

    SNACKBAR_DEFAULT_ERROR: 'Oops! ocurrió un error, inténtelo más tarde',
    SNACKBAR_DEFAULT_SUCCESS:
      'El reporte se está generando, en breves recibirás un correo con el resultado.',
    SNACKBAR_REPORT_EXISTS_ERROR:
      'Ya existe un reporte de este tipo en proceso de generación. Por favor, espere a que finalice antes de solicitar uno nuevo.',

    SEARCH_BY_USERS_HINT: 'Buscar por usuarios',

    HEADER_BACK_BUTTON_VIEW: 'Regresar',

    TOUR_BUTTON_AGAIN: 'Ver otra vez',
    TOUR_BUTTON_START: 'Comenzar',
    TOUR_BUTTON_NEXT: 'Siguiente',
    TOUR_TITLE_LAST: '¡Excelente trabajo!',
    TOUR_DESCRIPTION_LAST:
      'Ya estás listo para empezar. Si quieres revivir este Onboarding más adelante, puedes ir a Guía del Administrador. Tenemos para ti muchos más recursos que te pueden servir para sacarle provecho a la plataforma.',

    ERROR_CASE_TITLE: 'Oops, ocurrió un error',
    ERROR_CASE_BODY:
      'Inténtelo más tarde, o presione el botón de abajo para reintentar',
    ERROR_CASE_BUTTON: 'Actualizar',

    STUDENT_COUNTER_BEGINNER: 'Principiante',
    STUDENT_COUNTER_MIDDLE: 'Intermedio',
    STUDENT_COUNTER_ADVANCED: 'Avanzado',
    STUDENT_COUNTER_PERSONS: '{{count}} persona',
    STUDENT_COUNTER_PERSONS_plural: '{{count}} personas',

    FAQ_DIALOG_TITLE: 'Preguntas frecuentes',
    FAQ_DIALOG_BODY: 'En caso tengas una consulta adicional escribe a',

    ERROR_MESSAGE_TITLE: 'Oops, algo salió mal',
    ERROR_MESSAGE_SUBTITLE: 'por favor, inténtelo más tarde.',
    ERROR_MESSAGE_BUTTON: 'Intentar de nuevo',

    INBOX_PANEL_BUTTON: 'Ver todos los mensajes',
    INBOX_PANEL_NO_MESSAGES: 'Aún no tienes mensajes',
    INBOX_PANEL_GO_CHAT: 'Ir al chat',
    INBOX_PANEL_CHAT: 'Chat de mentores',

    INBOX_ITEM_SEND_IMAGE_1: 'Enviaste una imagen',
    INBOX_ITEM_SEND_IMAGE_2: 'Envió una imagen',
    INBOX_ITEM_SEND_FILE_1: 'Enviaste un archivo',
    INBOX_ITEM_SEND_FILE_2: 'Envió un archivo',
    INBOX_ITEM_SEND_CHAT_1: 'Iniciaste una conversación',
    INBOX_ITEM_SEND_CHAT_2: 'Inició una conversación',
    INBOX_ITEM_SPECIALIZATION: 'Especialización',

    NEWS_TITLE: 'Lo último en Crehana',
    NEWS_TAB_UPDATES: 'Updates',
    NEWS_TAB_COURSES: 'Cursos',

    DEFAULT_BUTTON_AGAIN: 'Reintentar',
    DEFAULT_LABEL_NEWS:
      '¡Pronto descubrirás todas las novedades que tenemos para ti!',

    NEWS_NOTIFICATIONS_LABEL: 'Notificaciones',

    DASHBOARD_LIST: 'Mis perfiles',
    DASHBOARD_LX: 'Panel del estudiante',
    DASHBOARD_LX_SM: 'Estudiante',
    DASHBOARD_LEADER: 'Líder',
    DASHBOARD_ADMIN: 'Administrador',

    PROFILE_ACCOUNT: 'Cuenta',
    PROFILE_PROFESSOR: 'Panel de Profesor',
    PROFILE_MENTOR: 'Mentor',
    PROFILE_ADMIN: 'Administrador',
    PROFILE_LEADER: 'Líder',
    PROFILE_MEMBER: 'Colaborador',
    PROFILE_COURSES: 'Mis cursos',
    PROFILE_PROFILE: 'Mi Perfil',
    PROFILE_MANAGE_ACCOUNT: 'Configurar cuenta',
    PROFILE_HELP_CENTER: 'Centro de ayuda',
    PROFILE_PANEL: 'Panel',
    PROFILE_NIGHTSWITCH: 'Modo Nocturno',
    PROFILE_CONFIGURATION: 'Configuración',
    PROFILE_MENTORS: 'Mentores',
    PROFILE_LOGOUT: 'Cerrar sesión',

    SEARCH_HEADER_HINT_1: 'Buscar usuarios',
    SEARCH_HEADER_HINT_2: 'u organizaciones',
    SEARCH_HEADER_HINT_3: 'o rutas',
    SEARCH_HEADER_USERS: 'Usuarios',
    SEARCH_HEADER_TRACKS: 'Rutas',
    SEARCH_HEADER_ORGANIZATIONS: 'Organizaciones',
    SEARCH_EMPTY_TITLE: ' No se han encontrado resultados',
    SEARCH_EMPTY_SUBTITLE: 'Prueba palabras clave más generales',
    SEARCH_ALL_RESULTS: 'Ver todos los resultados',

    DEFAULT_SEARCH_HINT: 'Buscar',

    MENU_ROUTE_MY_SHOP: 'Tienda',
    MENU_ROUTE_CONTENT: 'Agrega contenido',
    MENU_ROUTE_METRICS_1: 'Estadísticas',
    MENU_ROUTE_METRICS_NEW: 'Analítica',
    MENU_ROUTE_ADMIN: 'Administrar',
    MENU_ROUTE_PROJECTS: 'Proyectos',
    MENU_ROUTE_CERTIFICATES_GALLERY: 'Certificados',
    MENU_ROUTE_KNOWLEDGE_HUB_DOCUMENTS: 'Documentos',
    MENU_ROUTE_KNOWLEDGE_HUB_CATALOG: 'Catálogo',
    MENU_ROUTE_SKILL_IQ: 'Skill XP',
    MENU_ROUTE_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
    MENU_ROUTE_INTEGRATIONS: 'Integraciones',
    MENU_ROUTE_CLASSROOM: 'Classrooms',
    MENU_ROUTE_STUDIO: 'Studios',
    MENU_ROUTE_ELEVATE: 'Elevate',
    MENU_ROUTE_ELEVATE_CONTENT: 'Contenido',
    MENU_ROUTE_GAMIFICATION: 'Gamificación',
    MENU_ROUTE_CONFIG: 'Configuración',
    MENU_ROUTE_GUIDE: 'Ayuda',
    MENU_ROUTE_METRICS_2: 'Estadísticas',
    MENU_ROUTE_ADMIN_2: 'Administrar',
    MENU_ROUTE_TALENT: 'Talent',
    MENU_ROUTE_CONFIG_2: 'Configuración',
    MENU_ROUTE_INDUCTION: 'Inducción',
    MENU_ROUTE_FEEDBACK: 'Feedback',
    MENU_ROUTE_REPORTS: 'Reportes',
    MENU_ROUTE_HELP: 'Soporte',
    MENU_ROUTE_NEW_HELP: 'Ayuda',
    REPORTS_NESTED_ROUTE_1: 'Publicados',
    REPORTS_NESTED_ROUTE_2: 'Personalizado',
    REPORTS_NESTED_ROUTE_3: 'Programados',
    REPORTS_NESTED_ROUTE_4: 'Programar',

    MENU_LEADER_METRICS: 'Estadísticas',
    MENU_LEADER_PROJECTS: 'Proyectos',
    MENU_LEADER_GUIDE: 'Guía del líder',

    LEADER_METRICS_NESTED_1: 'General',
    LEADER_METRICS_NESTED_2: 'Por usuarios',

    ROUTE_MARKET_CONFIG: 'Configuración',

    MENU_ROUTE_CONTENT_1: 'Rutas de aprendizaje',
    MENU_ROUTE_CONTENT_3: 'Rutas Ecommerce',
    MENU_ROUTE_CONTENT_2: 'Cursos propios',
    MENU_ROUTE_CONTENT_4: 'Sesiones en vivo',
    MENU_ROUTE_HANA_AI: 'Crehana AI',

    STATISTICS_LEARNING: 'Aprendizaje',
    GENERAL_NESTED_ROUTE_1: 'General',
    GENERAL_NESTED_ROUTE_2: 'Por usuarios',
    GENERAL_NESTED_ROUTE_3: 'Por rutas',
    GENERAL_NESTED_ROUTE_4: 'Por cursos',

    ROUTE_MANAGE_NESTED_1: 'Atributos',
    ROUTE_MANAGE_NESTED_2: 'Usuarios',
    ROUTE_MANAGE_NESTED_3: 'Por rutas',
    ROUTE_MANAGE_NESTED_4: 'Equipos',
    ROUTE_MANAGE_NESTED_5: 'Automatizaciones',
    ROUTE_MANAGE_NESTED_6: 'Atributos personalizados',
    ROUTE_MANAGE_NESTED_5_1: 'Nueva automatización',
    ROUTE_MANAGE_NESTED_5_2: 'Editar automatización',
    ROUTE_MANAGE_NESTED_5_3: 'Detalle de usuarios',

    ROUTE_CORP_MANAGE_1: 'Por organizaciones',
    ROUTE_CORP_MANAGE_2: 'Por administradores',

    ROUTE_TALENT_NESTED_1: 'Gestión de talento',
    ROUTE_TALENT_NESTED_2: 'Engagement',
    ROUTE_TALENT_NESTED_3: 'Desempeño',

    CONFIGURATION_NESTED_1: 'Cuenta',
    CONFIGURATION_NESTED_2: 'Apariencia',
    CONFIGURATION_NESTED_3: 'Comunicaciones',
    CONFIGURATION_NESTED_4: 'Certificaciones',

    INTEGRATIONS_NESTED_ROUTE_1: 'Descubre',
    INTEGRATIONS_NESTED_ROUTE_2: 'Mis integraciones',
    INTEGRATIONS_NESTED_ROUTE_3: 'Personalización',
    INTEGRATIONS_NESTED_ROUTE_4: 'Credenciales',

    SKILL_IQ_GENERAL_NESTED_1: 'General',
    SKILL_IQ_GENERAL_NESTED_2: 'Por usuarios',
    SKILL_IQ_GENERAL_NESTED_3: 'Por Rutas',

    SKILL_XP_EVOLUTION_NESTED_1: 'Lanzados',
    SKILL_XP_EVOLUTION_NESTED_2: 'Resultados',

    REPORTS_NESTED_1: 'Reportes',
    REPORTS_NESTED_2: 'Reporte personalizado',

    GAMIFICATION_NESTED_1: 'Progreso',
    GAMIFICATION_NESTED_2: 'Recompensas',

    NEW_ROUTE: 'Nuevo',

    SIDEBAR_TITLE_DARK_MODE: 'Modo nocturno',
    SIDEBAR_MENU_TITLE: 'Mi panel',

    DEFAULT_SEE_DETAIL: 'Ver detalle',

    NEWS_DIALOG_TYPE: 'NUEVO EN EL PANEL',
    NEWS_DIALOG_COURSE_TYPE: 'NUEVO CURSO',
    NEWS_DIALOG_BTN_DETAIL: 'Ver detalle',

    HEADER_PREVIEW_DURATION: 'Duración: ',
    HEADER_PREVIEW_LEVEL: 'Nivel: ',
    HEADER_PREVIEW_MANDATORY: 'Obligatorio: ',
    HEADER_PREVIEW_MANDATORY_YES: 'Si',
    HEADER_PREVIEW_MANDATORY_NO: 'No',
    HEADER_PREVIEW_CERTIFICATION_AVAILABLE: 'Certificado',
    HEADER_PREVIEW_CERTIFICATION_UNAVAILABLE: 'Sin certificado',
    HEADER_PREVIEW_ACTIVE: 'Activo',
    HEADER_PREVIEW_INACTIVE: 'Desactivado',
    PREVIEW_VIDEO_TRAILER: 'Ver trailer',
    PREVIEW_VIDEO_OWN_COURSE: 'Curso propio',

    COURSE_DETAIL_NESTED_ROUTE_GENERAL: 'General',
    COURSE_DETAIL_NESTED_ROUTE_PROJECTS: 'Proyectos',
    COURSE_DETAIL_NESTED_ROUTE_REVIEWS: 'Comentarios',
    COURSE_DETAIL_NESTED_ROUTE_EVALUATIONS: 'Evaluaciones',
    COURSE_DETAIL_NESTED_ROUTE_REPORT_SURVEY: 'Encuesta',
    COURSE_DETAIL_NESTED_ROUTE_LIVE_SESSIONS: 'Sesiones en vivo',

    USER_COURSE_DRAWER_TITLE: 'Asignar curso',
    USER_COURSE_DRAWER_TITLE_2:
      'En el panel del estudiante, el curso se mostrará en “Cursos asignados para ti” y no asociado a una ruta de aprendizaje.',
    USER_COURSE_DRAWER_CANCEL: 'Cancelar',
    USER_COURSE_DRAWER_ASSIGN: 'Asignar',
    USER_COURSE_DRAWER_HINT_1: 'Usuarios',
    USER_COURSE_DRAWER_HINT_2:
      'Busca a los usuarios que asignarás a este curso.',
    USER_COURSE_DRAWER_PLACEHOLDER: 'Escribe el nombre o correo del usuario',
    USER_COURSE_DRAWER_NOT_FOUND: 'No se han encontrado usuarios',
    USER_COURSE_DRAWER_DONE_TITLE_1: 'Este curso se asignó a',
    USER_COURSE_DRAWER_DONE_TITLE_2: 'usuario(s)',
    USER_COURSE_DRAWER_DONE_SUBTITLE:
      'Accederá(n) al curso desde el panel del estudiante',
    USER_COURSE_DRAWER_DONE_BUTTON: 'Entendido',

    TABS_SOON_AVAILABLE_TITLE: 'Disponible próximamente',

    TABLE_EMPTY_STATE_1: 'Lo sentimos, no se encontraron resultados',
    TABLE_EMPTY_STATE_2: 'Inténtalo de nuevo con un término diferente.',

    TABLE_CONTAINER_SELECTED: 'Seleccionados',
    TABLE_CONTAINER_DELETE: 'Eliminar',

    GLOBAL_CANCEL: 'Cancelar',
    GLOBAL_CONTINUE: 'Continuar',
    GLOBAL_ACCEPT_CONTINUE: 'Si, continuar',
    GLOBAL_UNDERSTAND: 'Entendido',
    GLOBAL_REQUIRED_FIELDS: '* Campos obligatorios',

    LAST_UPDATE_GENERAL:
      'Última actualización de la información: {{date}} a las 00:00 horas.',
    LAST_SYNC_REAL: 'Última actualización de la información: {{datetime}}.',
    LAST_UPDATE_GENERAL_DESC:
      'Los gráficos solo muestran las horas de estudio de los usuarios activos.',

    REPORT_1_TITLE: 'Reporte general',
    REPORT_1_DESCRIPTION:
      'Progreso de la organización, detalle por cursos, performance de usuarios y actividad de la cuenta',
    REPORT_2_TITLE: 'Usuarios de la organización',
    REPORT_2_DESCRIPTION:
      'Usuarios agregados a la plataforma (activos y pendientes), incluye atributos y etiquetas',
    REPORT_3_TITLE: 'Usuarios pendientes',
    REPORT_3_DESCRIPTION:
      'Usuarios que aún no activan sus cuentas de Crehana for business',
    REPORT_4_TITLE: 'Usuarios sin iniciar cursos',
    REPORT_4_DESCRIPTION:
      'Usuarios que activaron sus cuentas, pero que no han iniciado ningún curso',
    REPORT_5_TITLE: 'Rutas de aprendizaje general',
    REPORT_5_DESCRIPTION:
      'Progreso de todas las rutas publicadas, incluye el detalle de los usuarios asignados',
    REPORT_6_TITLE: 'Reporte de curso',
    REPORT_6_DESCRIPTION: 'Progreso de tus usuarios en el curso "{{title}}"',
    REPORT_7_TITLE: 'Reporte de ruta',
    REPORT_7_DESCRIPTION: 'Progreso de tus usuarios en la ruta "{{title}}"',
    REPORT_8_TITLE: 'Equipos',
    REPORT_8_DESCRIPTION:
      'Estado de actividad de los líderes con información sobre las personas a cargo y enlaces a las estadísticas del equipo.',
    REPORT_9_TITLE: 'Resultado de Eval. como clase',
    REPORT_9_DESCRIPTION:
      'Resumen general de los resultados de evaluaciones como clase en todos los cursos.',
    REPORT_10_TITLE: 'Detalle de Eval. como clase',
    REPORT_10_DESCRIPTION:
      'Detalle que presentan todas las preguntas y respuestas registradas por los usuarios.',
    REPORT_11_TITLE: 'Reporte de Evaluaciones y general',
    REPORT_11_DESCRIPTION:
      'Resultado de evaluaciones sumado a un reporte general con filtros de usuarios activos',
    SEND_REPORT: 'Enviar reporte',
    TITLE_BUTTON_REDIRECT: 'Ver reportes',

    ROUTEITEM_DETAIL_ROUTES_COURSES: 'cursos',
    ROUTEITEM_DETAIL_ROUTES_REQ: 'Requisitos:',
    ROUTEITEM_DETAIL_ROUTES_QUIZES: '{{count}} evaluaciones',
    ROUTEITEM_DETAIL_ROUTES_PROJECT: '1 proyecto',
    ROUTEITEM_DETAIL_ROUTES_COURSES_TITLE: 'CURSOS DE LA RUTA',

    CARDCOURSE_DETAIL_COURSE_REQUIRED: 'Obligatorio',
    CARDCOURSE_DETAIL_COURSE_PROFESSOR: 'Por {{name}}',
    CARDCOURSE_DETAIL_COURSE_MODULES: '{{count}} módulos',

    MULTISELECT_TABLE_CONTAINER_SELECTED: 'seleccionado(s) de esta página',
    MULTISELECT_TABLE_CONTAINER_SELECTED_PARTIAL: 'items seleccionados',
    MULTISELECT_TABLE_CONTAINER_SELECTED_ALL:
      'Todos los {{items}} items se han seleccionado',
    MULTISELECT_TABLE_CONTAINER_SELECT_ALL:
      'Seleccionar los {{totalItems}} items',
    MULTISELECT_TABLE_CONTAINER_DELETE: 'Anular selección',

    INDUCTION_NESTED_1: 'Resumen',
    INDUCTION_NESTED_2: 'Workflow',
    INDUCTION_NESTED_3: 'Documentos',
    INDUCTION_NESTED_4: 'Seguimiento',
    INDUCTION_NESTED_5: 'Etapas',

    ROUTES_REPORT_TITLE: '¡Listo! Estamos preparando su reporte',
    ROUTES_REPORT_TITLE_BODY:
      'En breves minutos, estaremos enviando a su correo electrónico el reporte excel con la información solicitada. También estará disponible en la sección de Reportes como parte del historial de reportes generados en la plataforma.',
    ROUTES_REPORT_TITLE_BUTTON: 'Entendido',

    REPORTS_TAB_DIALOG_BUTTON: 'Ver reportes',

    UPLOAD_DEFAULT_ERROR: 'Oops ocurrió un error, inténtelo más tarde',

    HEADER_HELP: 'Ayuda',

    STEP_2_SUBTITLE: 'Verificaremos que todo esté bien con tu archivo',
    MASSIVE_STEP_1_INPUT_INVALID_FORMAT: 'Formato inválido',
    MASSIVE_STEP_1_INPUT_INVALID_FORMAT_DESC:
      'Asegúrese de que el archivo esté en un formato válido, como .xlsx.',

    //Editor message
    NOTIFICATION_TITLE: 'Centro de mensajería para envíos de correo',
    NOTIFICATION_SUBTITLE:
      'Envía correos a tu equipo y personaliza los detalles para asegurar, que todos reciban la información adecuada.',
    NOTIFICATION_CTA_SEND: 'Enviar correo de prueba',
    NOTIFICATION_SEND: 'Enviar',
    NOTIFICATION_LOADING: 'Cargando Imagen',
    NOTIFICATION_REEMPLACE: 'Reemplazar imagen',
    NOTIFICATION_ERROR_LABEL: 'Ocurrió un error en la subida',
    NOTIFICATION_RETRY: 'Reintentar',
    NOTIFICATION_SUBMIT_PLACEHOLDER: 'Ingresa asunto del correo',
    NOTIFICATION_SUBMIT_LABEL: 'Asunto del correo ***(*Obligatorio)***',
    NOTIFICATION_SUBMIT:
      '¡Asegúrate de completar tu ruta antes de que venza el tiempo!',
    NOTIFICATION_SUBMIT_COURSE:
      'Tienes un curso sin completar; no olvides finalizarlo.',
    NOTIFICATION_SUBMIT_SESSION:
      'Queda poco para que comience tu sesión en vivo. ¡No te la pierdas!',
    NOTIFICATION_TEXTAREA_PLACEHOLDER: 'Ingresa un titulo',
    NOTIFICATION_ERROR_SIZE: 'Tu archivo excede el peso máximo',
    NOTIFICATION_PROGRESS_LABEL: 'Subiendo imagen',
    NOTIFICATION_ATTACHMENT: 'Subir archivo adjunto',
    NOTIFICATION_ERROR_INPUT: 'Debes completar este campo',
    NOTIFICATION_ATTACHMENT_WARNING: '(Máx. 3 archivos, peso máx: 20MB)',
    NOTIFICATION_TOAST_SUCCESS_TITLE:
      'El correo de prueba se envió correctamente.',
    NOTIFICATION_TOAST_SUCCESS_SUBTITLE:
      'Revisa tu casilla de correo, o mensajes no deseados.',
    NOTIFICATION_TOAST_ERROR_TITLE:
      'Se produjo un error al enviar el correo de prueba',
    NOTIFICATION_TOAST_ERROR_SUBTITLE: 'Inténtalo nuevamente más tarde..',
    NOTIFICATION_TOAST_LOADING_TITLE: 'Estamos enviando el correo de prueba',
    NOTIFICATION_TOAST_LOADING_SUBTITLE:
      'Esta acción puede demorar unos minutos',
    NOTIFICATION_DROP_TEXT:
      'Arrastra tu imagen para cargarlo o *elige tu archivo*',
    NOTIFICATION_WARNING: 'Tamaño: 600 x 192 px, Max: 2 MB, Formato: PNG, JPG',
    NOTIFICATION_CTA_PATH: 'Ir a la ruta',
    NOTIFICATION_CTA_COURSE: 'Ir al curso',
    NOTIFICATION_CTA_SESSION: 'Ver próximas sesiones',

    NOTIFICATION_CUSTOM_TITLE: 'Completa la ruta {{customTitle}}',
    NOTIFICATION_CUSTOM_TITLE_COURSE: 'Completa el curso: {{customTitle}}',
    NOTIFICATION_CUSTOM_TITLE_SESSION: 'Ingresar a la sesión: {{customTitle}}',
    NOTIFICATION_ATTACHMENT_RETRY: 'Intentar de nuevo',
    FILE_SIZE_ERROR: 'El peso de los archivos supera el límite permitido.',
    NOTIFICATION_TOAST_SUCCESS_EMAIL_TITLE:
      'El correo fue enviado con éxito a los usuarios seleccionados.',
    NOTIFICATION_TOAST_ERROR_EMAIL_TITLE:
      'Se produjo un error al enviar el correo a los usuarios seleccionados.',
    NOTIFICATION_TOAST_ERROR_EMAIL_SUBTITLE: 'Inténtalo nuevamente más tarde.',
    NOTIFICATION_CUSTOM_TOOLTIP:
      'Este correo de prueba será enviado al correo con el que estás logueado como administrador',
    NOTIFICATION_ATTACHMENT_HELPER:
      'Formatos permitidos: JPG, JPEG, PNG, GIF, BMP, PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX y ZIP',

    // dropdown filter by tabs
    BACK: 'Volver',
    DASHBOARD_FILTER_SELECTOR_BUTTON: 'Filtrar por',
    DASHBOARD_FILTER_VIEW_ALL: 'Ver todo',
    DASHBOARD_FILTER_SELECTOR_TITLE_1: 'Por atributos',
    DASHBOARD_FILTER_SELECTOR_TITLE_ATTR: 'Atributos',
    DASHBOARD_FILTER_SELECTOR_DESC_1:
      'Utiliza criterios para filtrar usuarios en función de los atributos con los que han sido etiquetados.',
    DASHBOARD_FILTER_SELECTOR_TITLE_2: 'Reglas de segmentación',
    DASHBOARD_FILTER_SELECTOR_DESC_2:
      'Agrupa usuarios con base a diferentes segmentos de datos predefinidos.',
    DASHBOARD_FILTER_SELECTOR_TITLE_3: 'Filtros guardados',
    DASHBOARD_FILTER_SELECTOR_DESC_3:
      'Accede aquí a las vistas guardadas para segmentar información rápidamente.',
    DASHBOARD_FILTER_SELECTOR_TITLE_4: 'Usuarios',
    DASHBOARD_FILTER_SELECTOR_DESC_4:
      'Agrupa usuarios con base a diferentes segmentos de datos predefinidos.',
    DASHBOARD_FILTER_SELECTOR_TOOLTIP: 'WIP',
    DASHBOARD_USERS_FILTER_ASC: 'Ascendente',
    DASHBOARD_USERS_FILTER_DES: 'Descendente',
    DASHBOARD_USERS_FILTER_ORDER: 'Ordenar por',
    DASHBOARD_USERS_FILTER_ALPHABETICAL: 'Alfabético',
    DASHBOARD_USERS_FILTER_NUMERIC: 'Numérico',
    DASHBOARD_USERS_FILTER_DATE: 'Fecha',
    DASHBOARD_FILTERS_ATTRIBUTES_APPLY: 'Aplicar',
    DASHBOARD_FILTERS_ATTRIBUTES_ADD: 'Agregar',
    DASHBOARD_FILTERS_ATTRIBUTES_ADD_SEGMENT: 'Agrega un segmento',
    DASHBOARD_FILTERS_ATTRIBUTES_RANGE: 'a',
    DASHBOARD_FILTERS_NOT_DATA_TITLE: 'Aún no tienes atributos creados',
    DASHBOARD_FILTERS_NOT_DATA_SUBTITLE:
      'Agrega nuevos atributos a tus usuarios para desbloquear funciones avanzadas de filtrado.',
    DASHBOARD_FILTERS_NOT_DATA_LINK: 'Crear atributos',
    SAVE_FILTERS: 'Guardar filtros',
    APPLY_FILTERS: 'Aplicar filtros',
    DASHBOARD_FILTERS_ATTRIBUTES_REMOVE: 'Eliminar filtro',
    DASHBOARD_FILTERS_ATTRIBUTES_EDIT: 'Editar filtro',
    SAVE_FILTERS_NAME_INPUT: 'Ingresa un nombre para tu filtro',
    SAVE_FILTERS_NAME_PLACEHOLDER: 'Espacio para escribir un texto',
    SAVE_FILTERS_BUTTON_SAVE: 'Guardar',
    SAVE_FILTERS_BUTTON_CANCEL: 'Cancelar',
    SAVE_FILTERS_ERROR_REQUIRED: 'El campo nombre es requerido',
    SAVE_FILTERS_ERROR_MESSAGE: 'Ha ocurrido un error al guardar el filtro',
    SAVED_FILTERS_OPTIONS_SELECTED: 'Opciones seleccionadas',
    SAVED_FILTERS_ERROR_TITLE: 'Hubo un error cargando la información',
    SAVED_FILTERS_ERROR_SUBTITLE:
      'Haz clic en el botón para intentar cargar nuevamente.',
    SAVED_FILTERS_ERROR_RETRY_BUTTON: 'Reintentar',
    UPDATE_FILTERS_ERROR_MESSAGE:
      'Ha ocurrido un error al actualizar el filtro',
    SEARCH_FILTER_SAVE: 'Buscar filtros guardados',
    SEARCH_FILTER_LABEL:
      'Selecciona una opción de filtros guardados para filtrar información:',

    NUMERIC_LABEL_PLACEHOLDER: 'Agrega un segmento',
    NUMERIC_RADIO_1: 'Es igual a',
    NUMERIC_RADIO_2: 'No contiene',
    NUMERIC_RADIO_3: 'Rango de',
    NUMERIC_RADIO_4: 'Termina en',
    NUMERIC_RADIO_5: 'Comienza en',
    NUMERIC_RADIO_6: 'Cualquier valor',
    NUMERIC_RADIO_7: 'Contiene',

    ATTRIBUTES_TAGS: 'etiquetas',
    ATTRIBUTES_DELETE: 'Borrar todo',
    ATTRIBUTES_NOT_FOUND_TITLE: 'No se encontraron resultados para',
    ATTRIBUTES_NOT_FOUND_SUBTITLE:
      'Inténtalo de nuevo con un término diferente.',
    ATTRIBUTES_PLACEHOLDER_SEARCH: 'Buscar atributo de usuario',

    STEP_1_SEGMENTATION_RULES_LIST_DESC_1:
      'Filtra a los usuarios que coincidan con ',
    STEP_1_SEGMENTATION_RULES_LIST_DESC_2: 'todas',
    STEP_1_SEGMENTATION_RULES_LIST_DESC_3: ' las siguientes condiciones:',
    STEP_1_SEGMENTATION_RULES_DELETE_ALL: 'Eliminar todo',
    STEP_1_SEGMENTATION_RULES_ITEMS_MAX:
      'Llegaste al límite de 5 reglas como máximo.',
    STEP_1_SEGMENTATION_RULES_ITEMS_ADD: 'Agregar regla',
    LIST_ATTRIBUTES_ITEM_1: 'Alfabético',
    LIST_ATTRIBUTES_ITEM_2: 'Numérico',
    LIST_ATTRIBUTES_ITEM_3: 'Fecha',
    SEGMENTATION_LABEL_DROPDOWN_1: 'Condicional',
    SEGMENTATION_LABEL_DROPDOWN_2: 'Etiquetas',
    ERROR_CHECK_DC3_TEMPLATES:
      'Hubo un error al verificar si la organización tiene certificados DC3',
    TRACKS_EXPORT_BUTTON_LABEL: 'Descargar Reporte',
  },
};

export default localeEs;
